import React from 'react';
import './App.css';
import Header from './components/Header';
import Nav from './components/Nav';
import AccountFooter from './components/AccountFooter';
import AdminGuard from './components/AdminGuard';
import RoleGate from './components/RoleGate';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './pages/Login';
import Landing from './pages/public/Landing';
import Pricing from './pages/public/Pricing';
import Welcome from './pages/public/Welcome';
import UserHome from './pages/UserHome';
import Skills from './pages/Skills';
import Packages from './pages/Packages';
import Suites from './pages/Suites';
import Overlays from './pages/Overlays';
import Signups from './pages/Signups';
import Users from './pages/Users';
import Customers from './pages/Customers';
import Workspaces from './pages/Workspaces';
import Entitlements from './pages/Entitlements';
import CreditPools from './pages/CreditPools';
import Agents from './pages/Agents';
import Runs from './pages/Runs';
import Approvals from './pages/Approvals';
import Audit from './pages/Audit';
import Integrations from './pages/Integrations';
import RoutingDemo from './pages/RoutingDemo';
import Goals from './pages/Goals';
import Tasks from './pages/Tasks';
import Footer from './components/Footer';
import { isAdmin } from './lib/roles';

function AppLayout() {
  const location = useLocation();
  const isPublicMarketing =
    location.pathname === '/' ||
    location.pathname === '/pricing' ||
    location.pathname === '/welcome';
  const isLoginPage = location.pathname === '/login';

  if (isPublicMarketing) {
    return (
      <Switch>
        <Route exact path="/" component={Landing} />
        <Route exact path="/pricing" component={Pricing} />
        <Route exact path="/welcome" component={Welcome} />
      </Switch>
    );
  }

  return (
    <div className={`app-shell ${isLoginPage ? 'app-shell--login' : ''} ${!isLoginPage && !isAdmin() ? 'app-shell--user' : ''}`}>
      {!isLoginPage && (
        <aside className="app-sidebar">
          <Header />
          <div className="app-sidebar__scroll">
            <Nav />
          </div>
          <AccountFooter />
        </aside>
      )}
      <div className="app-main">
        <Switch>
          <Route path="/login" component={Login} />
          <AdminGuard>
            <RoleGate>
              <Route exact path="/home" component={UserHome} />
              <Route exact path="/goals" component={Goals} />
              <Route exact path="/dashboard" component={Dashboard} />
              <Route path="/skills" component={Skills} />
              <Route path="/packages" component={Packages} />
              <Route path="/suites" component={Suites} />
              <Route path="/overlays" component={Overlays} />
              <Route path="/signups" component={Signups} />
              <Route path="/users" component={Users} />
              <Route path="/customers" component={Customers} />
              <Route path="/workspaces" component={Workspaces} />
              <Route path="/entitlements" component={Entitlements} />
              <Route path="/credit-pools" component={CreditPools} />
              <Route path="/agents" component={Agents} />
              <Route path="/runs" component={Runs} />
              <Route path="/routing" component={RoutingDemo} />
              <Route path="/tasks" component={Tasks} />
              <Route path="/approvals" component={Approvals} />
              <Route path="/integrations" component={Integrations} />
              <Route path="/audit" component={Audit} />
              <Route path="/reports" component={require('./pages/Reports').default} />
            </RoleGate>
          </AdminGuard>
        </Switch>
        {!isLoginPage && <Footer />}
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
